import { isObject } from '../../type_guards'
import { default as string } from '@poppinss/string'
import type { ElementCompact } from 'xml-js'

const isSimpleValue = (value: any): boolean => {
  switch (typeof value) {
    case 'string':
    case 'number':
    case 'boolean':
    case 'bigint':
      return true
    default:
      return false
  }
}

// Helper to convert primitive/array/object values into xml-js ElementCompact structure
export const toXmlValue = (value: any, parent?: string): any => {
  if (Array.isArray(value)) {
    return value.map((v) => (parent ? { [string.singular(parent)]: toXmlValue(v) } : toXmlValue(v)))
  }
  if (isObject(value)) {
    const out: ElementCompact = {}
    Object.entries(value).forEach(([k, v]) => {
      if (isSimpleValue(v)) {
        if (!out._attributes) {
          out._attributes = {}
        }
        out._attributes[k] = String(v)
        return
      } else {
        out[k] = toXmlValue(v, k)
      }
    })
    return out
  } else if (isSimpleValue(value)) {
    return { _text: String(value) }
  } else if (value === undefined) {
    return undefined
  } else {
    return {}
  }
  //   if (value === null || value === undefined) return undefined
  //   if (isSimpleValue(value)) {
  //     return { _text: String(value) }
  //   }
  //   if (Array.isArray(value)) {
  //     return value.map((v) => toXmlValue(v)).filter(Boolean)
  //   }
  //   if (typeof value === 'object') {
  //     const out: Record<string, any> = {}
  //     const attributes: Record<string, any> = {}

  //     Object.entries(value).forEach(([k, v]) => {
  //       const converted = toXmlValue(v)
  //       if (converted !== undefined) {
  //         // Simple values go to _attributes, complex values become child properties
  //         if (isSimpleValue(v)) {
  //           attributes[k] = String(v)
  //         } else {
  //           out[k] = converted
  //         }
  //       }
  //     })

  //     // Only add _attributes if there are any
  //     if (Object.keys(attributes).length > 0) {
  //       out._attributes = attributes
  //     }

  //     return out
  //   }
  //   return { _text: String(value) }
}
